<template>
<v-container fluid>
      <v-card-title class="text-h8 blue darken-4 lighten-1 py-1">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="h6" style="color:white!important;">
              <v-icon color="white">fact_check</v-icon>
              Invitaciones de encuestas
            </div>
          </v-col>
        </v-row>
        <v-row>
        </v-row>
      </v-card-title>    
        <v-row class="mx-2 mt-2"> 
          <v-col 
            cols="4"   
          >
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar"
              hide-details
              outlined
              dense
            />
          </v-col>
          <v-col cols="2">
          </v-col>
          <v-col cols="3">
               <v-btn 
                  large
                  color="blue"
                  @click="reenviarCorreoTodosParticipantes()"
                >
               <v-icon class="mr-2">mail</v-icon> 
                  Reenviar a todos
                </v-btn>
          </v-col>
            <v-col cols="3">
               <v-btn 
                  large
                  color="error"
                   @click="reenviarCorreoParticipantesPendientes()"
                >
               <v-icon class="mr-2">mail</v-icon> 
                  Enviar pendientes
                </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="search"
        calculate-widths
        loading-text="Cargando... Por favor espere"
        locale="es-ES"
      >
       <template v-slot:item.fechaEnvioCorreo="{ item }">
          {{ getDateFormated(item.fechaEnvioCorreo) }}
        </template>
      <template v-if="loading==false" v-slot:item.fechaConstestada="{ item }">
          {{ getDateFormated(item.fechaConstestada) }}
        </template>
      
        <template  v-if="loading==false" v-slot:item.encuestaContestada="{ item }">
<div v-if="item.encuestaContestada === 'SI'">
   <v-icon color="green">
           mdi-check 
          </v-icon>
      </div>
      <div v-else>
        <v-icon color="red">
          mdi-close
          </v-icon>
      </div>
</div></template>
   <template v-slot:item.acciones="{ item, item2 }">
          <v-row>
            <v-col cols="2" style="display:ruby;">            
              <v-btn v-if="item.perteneceGrupo === 'SI'&&item.encuestaContestada=='NO'"
                  large
                  color="success"
                 
                  @click="reenviarCorreoParticipante(item.idResultadoEncuesta)"
                >
               <v-icon class="mr-1" >mail</v-icon> 
                  Reenviar
                </v-btn>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
  <v-snackbar
    key="snackbarDataTableServicioResponsables"
    v-model="snackbar"
    :bottom="true"
    :multi-line="true"
    :color="snackbarColor"
  >
    {{ snackbarTexto }}
    <v-btn dark text @click="snackbar = false;">
      Cerrar
    </v-btn>
  </v-snackbar> 
</v-container>
</template>

<script>
import moment from 'moment'
import { format, parseISO } from 'date-fns'
import { mapGetters, mapActions, mapState } from "vuex";
import XLSX from 'xlsx';
import {getListadoResultadoEncuestaInvitaciones,postReenvairCorreoSolicitud,postReenviarCorreoSolicitudTodos } from "@/api";
export default {
  name: "DataTableInvitacionesEncuesta",
  components: {
     DialogIndicadoresEncuesta: () =>import("../bandejaEncuestas/IndicadoresEncuesta"),
  },
  props: {
    objEncuesta: {
      type: Object,
      required: true
    },
    flagReload: {
      type: Number,
      default: 0
    },
    fnOnLoaded: {
      type: Function,
      default: () => {}
    },
  },
  data () {
    return {
      loading: true,
      snackbar: false,
      flag2:2,
      loadingEnviar:false,
      snackbarColor: '',
      snackbarTexto: '',
      headers: [
        { align: "left", text: "Id", value: "idResultadoEncuesta" },
        { align: "left", text: "Nombre", value: "nombre" },
        { align: "left", text: "Correo", value: "correo" },
        { align: "left", text: "Campus", value: "campus" },
        { align: "left", text: "Respuesta", value: "encuestaContestada" },
        { align: "left", text: "Fecha de respuesta", value: "fechaConstestada" },
        { align: "left", text: "Tipo de participante", value: "tipoParticipante" },
        { align: "left", text: "Fecha Envio de correo", value: "fechaEnvioCorreo" },
        { align: "center", text: "Acciones", value: "acciones" }
      ],
      items: [],
      preguntas: [],
      itemsFilter: [],
      search: "",
      dialog: false,
      itemSelected: {},
      itemDelete: {},
      dialogEliminar:  false,
      loadingEliminar: false,
     itemsPreguntas:[],
      date1:"",
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      menu1: false,
      tipoReenviar:false,
    };
  },
  computed: {},
  watch: {
    flagReload: {
      handler (newValue, oldValue) {
       this.getListadoResultadoEncuestas();
			},
    },
  },
  async mounted () {
    this.getListadoResultadoEncuestas();
  },
  methods: {
    async reenviarCorreoParticipante(item){
      console.log(item);
      var self = this;
      self.loading = true;
      try{
      let response;
      response = await postReenvairCorreoSolicitud (item);
      if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
            self.snackbarTexto = "El correo fue reenviado correctamente" ;
            self.snackbarColor = "success";
            self.snackbar = true;
            self.loading = false;
            this.getListadoResultadoEncuestas();
            }
          } else {
            self.snackbarTexto = "DataTableEncuestaRoles: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableEncuestaRoles: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableEncuestaRoles: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      
}
},
async reenviarCorreoTodosParticipantes(){
      var self = this;
      console.log(self);
      self.loading = true;
      self.loadingEnviar=true;
      this.tipoReenviar=true;
      try{
      let response;
      response = await postReenviarCorreoSolicitudTodos (this.objEncuesta.idEncuesta, this.tipoReenviar);
      if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Guardado correcto") {
            self.snackbarTexto = "Los correos fueron reenviados correctamente" ;
            self.snackbarColor = "success";
            self.snackbar = true;
            self.loading = false;
            self.loadingEnviar=false;
            this.getListadoResultadoEncuestas();
            }
          } else {
            self.snackbarTexto = "DataTableEncuestaRoles: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableEncuestaRoles: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableEncuestaRoles: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
   }
 },
 async reenviarCorreoParticipantesPendientes(){
      var self = this;
      self.loading = true;
      this.tipoReenviar=false;
      try{
      let response;
      response = await postReenviarCorreoSolicitudTodos (this.objEncuesta.idEncuesta, this.tipoReenviar);
      if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Guardado correcto") {
           self.snackbarTexto = "Los correos pendientes fueron enviados" ;
            self.snackbarColor = "success";
            self.snackbar = true;
            self.loading = false;
            this.getListadoResultadoEncuestas();
            }
          } else {
            self.snackbarTexto = "DataTableEncuestaRoles: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableEncuestaRoles: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableEncuestaRoles: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
   }
 }, 
     async getListadoResultadoEncuestas () {
      var self = this;
      self.loading = true;
      self.items = [];
      self.itemsFilter = [];
      self.snackbarError = false;
      self.textoError = "";
      var fecha2 = self.date2;
      try {
        let response;
        response = await getListadoResultadoEncuestaInvitaciones(self.objEncuesta.idEncuesta);
     if (response.status === 200) {
          if (response.data.flag === true) {
            if (response.data.message === "Consulta correcta") {
              self.items = response.data.data;
              self.loading = false;
            }
          } else {
            self.snackbarTexto = "DataTableInvitacionesEncuesta: " + response.data.message;
            self.snackbarColor = "error";
            self.snackbar = true;
            self.loading = false;
          }
        } else {
          self.snackbarTexto = "DataTableInvitacionesEncuesta: Error de red";
          self.snackbarColor = "error";
          self.snackbar = true;
          self.loading = false;
        }
      } catch (e) {
        self.loading = false;
        self.snackbarTexto = "DataTableInvitacionesEncuesta: " + e;
        self.snackbarColor = "error";
        self.snackbar = true;
      }
    },
       getDateFormated(date) {
        if (date) {
        return moment(date).format('DD/MM/YYYY h:mm:ss a');
      }
    },
  }
};
</script>